export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-black text-background-50 font-heading">
                移动观影
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-200/80 max-w-md">
                随时随地看综艺！极速影院移动版适配手机和平板，通勤路上、午休间隙，精彩综艺触手可及。
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  { icon: 'ri-smartphone-line', text: '完美适配 iOS / Android 浏览器' },
                  { icon: 'ri-wifi-line', text: '智能省流模式，流量也能看高清' },
                  { icon: 'ri-moon-line', text: '深色护眼模式，夜间观影更舒适' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm text-background-200/80">
                    <div className="w-7 h-7 rounded-lg bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-primary-400 text-sm`}></i>
                    </div>
                    {item.text}
                  </li>
                ))}
              </ul>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="px-6 py-3 rounded-xl bg-background-50/10 border border-background-200/20 flex items-center gap-3 cursor-pointer hover:bg-background-50/20 transition-colors">
                  <i className="ri-apple-fill text-background-50 text-xl"></i>
                  <div className="text-left">
                    <p className="text-[10px] text-background-200/60">iOS 版本</p>
                    <p className="text-sm font-bold text-background-50 whitespace-nowrap">即将上线</p>
                  </div>
                </div>
                <div className="px-6 py-3 rounded-xl bg-background-50/10 border border-background-200/20 flex items-center gap-3 cursor-pointer hover:bg-background-50/20 transition-colors">
                  <i className="ri-android-fill text-background-50 text-xl"></i>
                  <div className="text-left">
                    <p className="text-[10px] text-background-200/60">Android 版本</p>
                    <p className="text-sm font-bold text-background-50 whitespace-nowrap">即将上线</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 p-6 md:p-8 flex justify-center">
              <div className="relative w-56 h-[400px] rounded-3xl bg-background-50/5 border border-background-200/10 overflow-hidden">
                <div className="absolute top-0 left-0 right-0 h-8 bg-background-50/10 flex items-center justify-center">
                  <div className="w-16 h-1.5 rounded-full bg-background-200/20"></div>
                </div>
                <div className="pt-10 px-4 space-y-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="flex gap-3 p-2 rounded-lg bg-background-50/5">
                      <div className="w-16 h-11 rounded-md bg-primary-500/20 flex-shrink-0"></div>
                      <div className="flex-1 space-y-1.5">
                        <div className="h-3 rounded bg-background-200/15 w-3/4"></div>
                        <div className="h-2 rounded bg-background-200/10 w-1/2"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}